module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    },
    domProps: {
      "checked": _vm.approve.approveType === 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(0)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("无需审批")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    },
    domProps: {
      "checked": _vm.approve.approveType === 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(2)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("限额审批")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    },
    domProps: {
      "checked": _vm.approve.approveType === 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("全部审批")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_tagWrap"
  }, [_c('div', {
    staticClass: "tagWrap research-background-color",
    on: {
      "click": function($event) {
        return _vm.updateMemberApproveType()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("请选择审批原则")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3200056c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupComponents/ChooseApproveType1.vue
// module id = 1591
// module chunks = 8